/* PrintFabrix — CFM pricing calculator (v2)
   PRICE = TOTAL_SQFT × PER_SQFT_PRICE + FLAT_FEE(range containing TOTAL_SQFT)
   Ranges + flat fees come from product/variant metafields (per-product data attributes on .pf-calc).
   If flat_fees data is missing, show "custom quote" instead of a computed price.
   NOTE: rate/flatFees/ranges are re-read from root.dataset on every recompute() so that
   clubbed products can swap variant-level pricing on the fly. */
(function(){
  var TO_FT = { ft:1, in:1/12, cm:0.0328084, m:3.28084 };

  var DEFAULT_RANGES = [
    [1,22],[23,60],[61,88],[89,100],[101,160],[161,225],[226,256],[257,300],
    [301,320],[321,375],[376,400],[401,450],[451,500],[501,600],[601,700],[701,800]
  ];
  var MIN_SQFT = 1;
  var MAX_SQFT = 800;

  function money(n){ return '$'+n.toFixed(2); }
  function num(el){ return Math.max(parseFloat(el && el.value) || 0, 0); }
  function tryParseJSON(s){ if(!s) return null; try{ return JSON.parse(s); } catch(e){ return null; } }

  function flatFor(ranges, fees, sqft){
    for (var i = 0; i < ranges.length; i++){
      var lo = ranges[i][0], hi = ranges[i][1];
      if (sqft >= lo && sqft <= hi){
        var v = fees[i];
        if (typeof v === 'number' && isFinite(v)) return v;
        for (var j = i - 1; j >= 0; j--){
          if (typeof fees[j] === 'number' && isFinite(fees[j])) return fees[j];
        }
        return null;
      }
    }
    return null;
  }

  function initCalc(root){
    var $ = function(s){ return root.querySelector(s); };
    function setv(sel, val){ var el = $(sel); if(el) el.value = val; }

    function recompute(){
      // Re-read pricing data from dataset on every recompute so GSM variant swaps work.
      var rate = parseFloat(root.dataset.rate || '');
      var priced = !isNaN(rate) && rate > 0;
      var flatFees = tryParseJSON(root.dataset.flatFees);
      var ranges = tryParseJSON(root.dataset.shippingRanges) || DEFAULT_RANGES;
      var hasCFM = priced && Array.isArray(flatFees) && flatFees.length === ranges.length;

      var unitEl = $('.pf-unit');
      var unit = unitEl ? unitEl.value : 'ft';
      var w = num($('.pf-w')) * (TO_FT[unit] || 1);
      var h = num($('.pf-h')) * (TO_FT[unit] || 1);
      var qty = Math.max(parseInt(($('.pf-qty')||{}).value) || 1, 1);
      var sqft = w * h * qty;

      var out = $('.pf-out');
      if (sqft <= 0){
        if (out) out.innerHTML = '<span class="pf-muted">Enter width and height</span>';
        return;
      }

      if (!hasCFM){
        if (out){
          out.innerHTML =
            '<div class="pf-por">Custom quote required for this fabric — '
            + '<a href="#pf-mockup">get a free quote &amp; mockup →</a></div>'
            + '<div class="pf-line pf-muted">Area: '+ sqft.toFixed(1) +' sq ft'+(qty>1?' · '+qty+' pcs':'')+'</div>';
        }
        var btnQ = root.querySelector('.pf-add'); if (btnQ) btnQ.disabled = true;
        return;
      }

      if (sqft < MIN_SQFT){
        if (out){
          out.innerHTML =
            '<div class="pf-por">Orders under '+MIN_SQFT+' sq ft need a manual quote — '
            + '<a href="#pf-mockup">request a quote →</a></div>'
            + '<div class="pf-line pf-muted">Area: '+ sqft.toFixed(1) +' sq ft'+(qty>1?' · '+qty+' pcs':'')+'</div>';
        }
        var btn0 = root.querySelector('.pf-add'); if (btn0) btn0.disabled = true;
        return;
      }

      if (sqft > MAX_SQFT){
        if (out){
          out.innerHTML =
            '<div class="pf-cap">Orders over '+MAX_SQFT+' sq ft need a custom shipping quote — '
            + '<a class="pf-oversize" href="#pf-mockup">submit a custom request →</a></div>'
            + '<div class="pf-line pf-muted">Area: '+ sqft.toFixed(1) +' sq ft'+(qty>1?' · '+qty+' pcs':'')+'</div>';
        }
        var btn1 = root.querySelector('.pf-add'); if (btn1) btn1.disabled = true;
        return;
      }

      var fabric = sqft * rate;
      var flat = flatFor(ranges, flatFees, sqft);
      if (flat === null){
        if (out) out.innerHTML = '<div class="pf-por">Custom quote required for this size — <a href="#pf-mockup">request →</a></div>';
        var btn2 = root.querySelector('.pf-add'); if (btn2) btn2.disabled = true;
        return;
      }
      var total = fabric + flat;
      var wt = Math.ceil(total);
      var flatShown = wt - fabric;

      var btn = root.querySelector('.pf-add'); if (btn) btn.disabled = false;

      if (out){
        out.innerHTML =
          '<div class="pf-line"><span>Fabric · '+ sqft.toFixed(1) +' sq ft × '+ money(rate) +'</span><b>'+ money(fabric) +'</b></div>'
        + '<div class="pf-line pf-muted"><span>Print + ship worldwide</span><span>'+ money(flatShown) +'</span></div>'
        + '<div class="pf-line pf-total"><span>Your price · printed, finished &amp; shipped'+(qty>1?' · '+qty+' pcs':'')+'</span><b>$'+ wt +'</b></div>';
      }

      root.dataset.sqft = sqft.toFixed(2);
      root.dataset.total = String(wt);
      root.dataset.flat = flat.toFixed(2);
      root.dataset.fabricSubtotal = fabric.toFixed(2);

      setv('.pf-qty-dollars', Math.max(1, wt));
      setv('.pfp-width',  ($('.pf-w')||{}).value + ' ' + unit);
      setv('.pfp-height', ($('.pf-h')||{}).value + ' ' + unit);
      setv('.pfp-unit',   unit);
      setv('.pfp-pieces', qty);
      setv('.pfp-area',   sqft.toFixed(1));
      setv('.pfp-total',  '$' + total.toFixed(2));
      var pockets = ($('.pf-pockets') || {}).value || '';
      var eyelets = ($('.pf-eyelets') || {}).value || '';
      var velcro  = ($('.pf-velcro')  || {}).value || '';
      setv('.pfp-pockets', pockets || 'None');
      setv('.pfp-eyelets', eyelets || 'None');
      setv('.pfp-velcro',  velcro  || 'None');
    }

    root.querySelectorAll('input,select').forEach(function(el){
      el.addEventListener('input',  recompute);
      el.addEventListener('change', recompute);
    });
    root._pfRecompute = recompute;
    root._pfInited = true;
    recompute();
  }

  document.addEventListener('DOMContentLoaded', function(){
    document.querySelectorAll('.pf-calc').forEach(initCalc);
  });
  window.PFCalc = { TO_FT: TO_FT, DEFAULT_RANGES: DEFAULT_RANGES, MIN_SQFT: MIN_SQFT, MAX_SQFT: MAX_SQFT, initCalc: initCalc };
})();


/* === PF-LADDER-ADDON (added 2026-07-23) — size-tier price ladder, ported from Backdropsource pricing logic.
   Pure addition: no existing logic modified. To revert, delete from this marker to end of file. === */
(function(){
  var TIERS=[
    {lbl:'Small',lo:1,hi:60,band:'up to 60 sq.ft'},
    {lbl:'Medium',lo:61,hi:160,band:'61\u2013160 sq.ft'},
    {lbl:'Large',lo:161,hi:400,band:'161\u2013400 sq.ft'},
    {lbl:'X-Large',lo:401,hi:99999,band:'400+ sq.ft'}
  ];
  var DEF_RANGES=[[1,22],[23,60],[61,88],[89,100],[101,160],[161,225],[226,256],[257,300],[301,320],[321,375],[376,400],[401,450],[451,500],[501,600],[601,700],[701,800]];
  function tryJSON(s){ if(!s) return null; try{ return JSON.parse(s) }catch(e){ return null } }
  function flatFor(ranges,fees,sqft){
    for(var i=0;i<ranges.length;i++){
      var lo=ranges[i][0],hi=ranges[i][1];
      if(sqft>=lo&&sqft<=hi){
        var v=fees[i];
        if(typeof v==='number'&&isFinite(v)) return v;
        for(var j=i-1;j>=0;j--){ if(typeof fees[j]==='number'&&isFinite(fees[j])) return fees[j] }
        return null;
      }
    }
    return null;
  }
  if(!document.getElementById('pf-ladder-style')){
    var st=document.createElement('style');
    st.id='pf-ladder-style';
    st.textContent='.pf-ladder{margin-top:10px;border:1px solid #eceae4;border-radius:10px;overflow:hidden;font-size:12.5px;font-family:inherit}.pf-ladder-row{display:flex;justify-content:space-between;align-items:center;gap:8px;padding:7px 12px;border-top:1px solid #f0eee9;color:#55555f}.pf-ladder-row:first-child{border-top:0}.pf-ladder-row.pf-here{background:#fceef4;color:#1a1a24}.pf-ladder-row.pf-here span:first-child{font-weight:600}.pf-ladder-row b{font-weight:700;white-space:nowrap}.pf-ladder-here{color:#e3157e;font-size:11px;margin-left:6px;font-weight:700}';
    document.head.appendChild(st);
  }
  function render(root){
    var out=root.querySelector('.pf-out'); if(!out) return;
    var lad=root.querySelector('.pf-ladder');
    var priced=!!out.querySelector('.pf-total');
    var hb=document.querySelector('.pf-price-line b');
    var hs=document.querySelector('.pf-price-line b + span');
    if(hb&&!hb.dataset.baseRate){ hb.dataset.baseRate=hb.textContent; if(hs&&!hs.dataset.baseNote) hs.dataset.baseNote=hs.textContent; }
    var sqft0=parseFloat(root.dataset.sqft||'0');
    var wt0=parseFloat(root.dataset.total||'0');
    if(priced&&hb&&sqft0>0&&wt0>0&&root.dataset.pfTouched==='1'){
      hb.textContent='$'+(Math.ceil(wt0/sqft0*100)/100).toFixed(2);
      if(hs) hs.textContent='per sq ft \u00b7 at your size';
    } else if(hb&&hb.dataset.baseRate){
      hb.textContent=hb.dataset.baseRate;
      if(hs&&hs.dataset.baseNote) hs.textContent=hs.dataset.baseNote;
    }
    var rate=parseFloat(root.dataset.rate||'');
    var fees=tryJSON(root.dataset.flatFees);
    var ranges=tryJSON(root.dataset.shippingRanges)||DEF_RANGES;
    if(!priced||!(rate>0)||!Array.isArray(fees)||!fees.length){ if(lad) lad.style.display='none'; return }
    if(!lad){ lad=document.createElement('div'); lad.className='pf-ladder'; out.parentNode.insertBefore(lad,out.nextSibling) }
    lad.style.display='';
    var maxHi=(ranges.length&&ranges[ranges.length-1][1])||800;
    var sqft=parseFloat(root.dataset.sqft||'0');
    var html='';
    TIERS.forEach(function(t){
      var ref=Math.min(t.hi>=99999?maxHi:t.hi,maxHi);
      var fl=flatFor(ranges,fees,ref); if(fl==null) return;
      var eff=Math.ceil((ref*rate+fl)/ref*100)/100;
      var here=sqft>0&&sqft>=t.lo&&(t.hi>=99999?true:sqft<=t.hi);
      html+='<div class="pf-ladder-row'+(here?' pf-here':'')+'"><span>'+t.lbl+' \u00b7 '+t.band+(here?'<span class="pf-ladder-here">\u2014 you\u2019re here</span>':'')+'</span><b>as low as $'+eff.toFixed(2)+'/sq.ft</b></div>';
    });
    lad.innerHTML=html;
  }
  function watch(root){
    var out=root.querySelector('.pf-out'); if(!out) return;
    ['.pf-w','.pf-h','.pf-unit','.pf-qty'].forEach(function(sel){
      var el=root.querySelector(sel);
      if(el){ el.addEventListener('input',function(){ root.dataset.pfTouched='1'; }); el.addEventListener('change',function(){ root.dataset.pfTouched='1'; }); }
    });
    try{ new MutationObserver(function(){ render(root) }).observe(out,{childList:true,subtree:true}) }catch(e){}
    render(root);
  }
  function initAll(){ document.querySelectorAll('.pf-calc').forEach(watch) }
  if(document.readyState==='loading'){ document.addEventListener('DOMContentLoaded',initAll) } else { initAll() }
})();
